import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter400 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        4. 確率・統計の基礎
        </Header>

<ol>
  <li><a href="1/index.html" target="_blank/1/index.html">基本的な確率分布一覧</a></li>
</ol>

      </div>
    )   
  }
}

export default Chapter400;
